import React from "react";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";

import Authenticator from "../../components/Authenticator/Authenticator";
import { isLoggedIn } from "../../state/selectors/user";

const styles = theme => ({
  card: {
    margin: theme.spacing(3)
  }
});

const Home = ({ classes, isAnonymous }) => {
  return (
    <Grid container justifyContent="center">
      <Grid item xs={6}>
        <Card className={classes.card}>
          <CardContent>
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
            >
              Welcome to survey tool. Please login to your account
            </Typography>
            {isAnonymous && <Authenticator />}
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = state => ({
  isAnonymous: !isLoggedIn(state),
});

export default connect(
  mapStateToProps,
)(withStyles(styles)(Home));